module.exports = __webpack_public_path__ + "static/media/skip-popup.595c54e0.jpg";